import React, { useEffect, useState } from "react";
import { tokens } from "../../../theme/theme";
import AddTaskIcon from '@mui/icons-material/AddTask';
import {
    Drawer,
    Button,
    Typography,
    Box,
    Divider,
    List,
    ListItem,
    IconButton,
    useTheme,
    Tooltip,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AddCircleOutline, AddCircleRounded, CheckCircleOutline, ErrorOutline, WarningAmber } from "@mui/icons-material";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { toast } from "react-toastify"; // optional for showing toast
import AddNewRequestIndent from "../../purchase/request-indent/AddRequestIndent";
import NoteAddIcon from '@mui/icons-material/NoteAdd';


const getStatusVisuals = (status) => {
    switch (status) {
        case 'CRITICAL – BELOW SAFETY STOCK':
            return {
                color: "#ef5350",
                icon: <ErrorOutline sx={{ color: "#ef5350" }} />,
            };
        case 'WARNING – REORDER REQUIRED':
            return {
                color: "#ffca28",
                icon: <WarningAmber sx={{ color: "#ffca28" }} />,
            };
        default:
            return null; // OK → don’t show
    }
};


const MaterialStockDrawer = ({ open, setOpen, SetActive, materialStockData, selectedItems, setSelectedItems, handleRaiseIndent }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";
    const colors = tokens(theme.palette.mode);

    const [selectAll, setSelectAll] = useState(false);

   const lowStockMaterials = materialStockData
    .map((item) => {
        const visuals = getStatusVisuals(item.stock_status);
        return visuals
            ? {
                  ...item,
                  color: visuals.color,
                  icon: visuals.icon,
              }
            : null;
    })
    .filter(Boolean);


    const handleToggle = () => {
        setOpen(!open);
        setSelectedItems([]);
        setSelectAll(false);
    };

    const callback = () => {
        setOpen(!open);
    }

    const handleSelectAll = (event) => {
        setSelectAll(event.target.checked);
        if (event.target.checked) {
            // setSelectedItems(lowStockMaterials.map((item) => item.name));
            setSelectedItems(lowStockMaterials);
        } else {
            setSelectedItems([]);
        }
    };

    // const handleItemSelect = (name) => {
    //     const updated = selectedItems.includes(name)
    //         ? selectedItems.filter((n) => n !== name)
    //         : [...selectedItems, name];
    //     setSelectedItems(updated);
    //     setSelectAll(updated.length === lowStockMaterials.length);
    // };

    const handleItemSelect = (name) => {
        const exists = selectedItems.find((item) => item.name === name);
        if (exists) {
            const updated = selectedItems.filter((item) => item.name !== name);
            setSelectedItems(updated);
            setSelectAll(updated.length === lowStockMaterials.length);
        } else {
            const newItem = lowStockMaterials.find((item) => item.name === name);
            const updated = [...selectedItems, newItem];
            setSelectedItems(updated);
            setSelectAll(updated.length === lowStockMaterials.length);
        }
    };


    return (
        <>
            <Drawer anchor="right" open={open} onClose={handleToggle}>
                <Box
                    width={350}
                    p={2}
                    sx={{
                        backgroundColor: isDark
                            ? theme.palette.background.default
                            : "#f9f9f9",
                        height: "100%",
                        color: theme.palette.text.primary,
                    }}
                >
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                       <Typography variant="h5">
    Material Stock Alerts
</Typography>

                        <IconButton onClick={handleToggle} color="inherit">
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    {/* Select All + Raise Button */}
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={selectAll}
                                    onChange={handleSelectAll}
                                    color="secondary"
                                />
                            }
                            label="Select All"
                        />
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleRaiseIndent}
                            disabled={selectedItems.length === 0}
                            sx={{ ml: 1, color: colors.primary[50], }}
                            startIcon={<NoteAddIcon />}
                        >
                            Raise Request Indent
                        </Button>
                    </Box>

                    {/* Scrollable List */}
                    <Box
                        sx={{
                            padding: "5px",
                            borderRadius: "10px",
                            maxHeight: {
                                xs: '72vh',
                                sm: '72vh',
                                md: '74vh',
                                lg: '74vh',
                                xl: '82vh',
                            },
                            overflowY: 'auto',
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        <List>
                            {lowStockMaterials.map((item, index) => (
                                <ListItem
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        mb: 2,
                                        border: `1px solid ${isDark ? "#444" : "#ddd"}`,
                                        borderRadius: 2,
                                        p: 1.5,
                                        backgroundColor: isDark ? "#1e1e1e" : "#fff",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        width="100%"
                                    >
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Checkbox
                                                size="small"
                                                // checked={selectedItems.includes(item.name)}
                                                checked={selectedItems.some((i) => i.name === item.name)}
                                                onChange={() => handleItemSelect(item.name)}
                                                color="secondary"
                                            />
                                            {/* {item.icon} */}
                                            <Typography variant="subtitle1">
                                                {item.name}
                                            </Typography>
                                        </Box>
                                    </Box>

                                   <Typography variant="body2">
    Available Stock: <b>{item.stock}</b>
</Typography>

<Typography variant="body2">
    Safety Stock: <b>{item.safety_stock}</b>
</Typography>

<Typography variant="body2">
    Reorder Level: <b>{item.reorder_level}</b>
</Typography>

<Typography variant="body2" sx={{ mt: 0.5 }}>
    Qty to Request: <b>{item.quantity_requested}</b>
</Typography>

<Typography
    variant="caption"
    sx={{
        mt: 0.5,
        color: item.color,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: 0.5,
    }}
>
    {item.icon}
    {item.stock_status}
</Typography>


                                    <Box
                                        mt={1}
                                        width="100%"
                                        height={2}
                                        borderRadius={5}
                                        sx={{
                                            backgroundColor: item.color,
                                            boxShadow: `0 0 4px ${isDark ? "#000" : "#ccc"}`,
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Box>
            </Drawer>

            {/* New Vendor */}

        </>
    );
};

export default MaterialStockDrawer;



